import React from 'react';
import { Grid } from '@mui/material';

import IInvestExpertiseFiltersResult from '@/apps/investor/interfaces/expertise/IInvestExpertiseFiltersResult';
import CInvestSynthesisListedAssetsFund from '@/apps/investor//features/fund-type/components/synthesis/listed_assets/CInvestSynthesisListedAssetsFund';
import { CGraphAssetsSynthesis } from '@/apps/investor//components/fund/CGraphAssetsSynthesis';
import { TInvestFundCurrency } from '@/apps/investor//types/fund/TInvestFundCurrency';

import { CCardStatsChart } from '@/app/components/Card/Stats/CCardStatsChart';
import { CCardStatsValues } from '@/app/components/Card/Stats/CCardStatsValues';
import { useTranslation } from 'react-i18next';
import investmentFundLang from '../../langs/investmentFundLang';

type VInvestExpertiseSynthesisListedAssetsProps = {
	resultData: IInvestExpertiseFiltersResult;
	currency: TInvestFundCurrency;
};

const VInvestExpertiseSynthesisListedAssets = (props: VInvestExpertiseSynthesisListedAssetsProps) => {
	const { resultData, currency } = props;
	const { t } = useTranslation();
	const kpis = resultData.kpisByFundForSiennaGestion?.filter((kpisByFund) => !!kpisByFund?.kpi);
	if (!kpis) return null;
	return (
		<>
			<Grid container spacing={2} paddingBottom={2} height="32rem">
				<Grid item xs={12} sm={6} height="100%">
					<CCardStatsChart
						title={t(investmentFundLang.title_portfolio_synthesis.tag)}
						chartComponent={
							<CGraphAssetsSynthesis
								data={kpis.map((kpi) => ({
									category: kpi.fund?.name ?? '',
									value: Number(kpi.kpi?.aum),
								}))}
								currency={currency}
							/>
						}
					/>
				</Grid>
				<Grid item xs={12} sm={6} height="100%">
					<CCardStatsValues
						title={t(investmentFundLang.title_my_holdings.tag)}
						rows={kpis.map((kpi) => ({
							label: kpi.fund?.name ?? '',
							value: kpi.kpi?.aum ?? 0,
							currency: (kpi.fund?.currency ?? 'EUR') as TInvestFundCurrency,
						}))}
					/>
				</Grid>
			</Grid>
			{kpis.map((kpi) => (
				<CInvestSynthesisListedAssetsFund key={kpi.fund?.id} investKpisByFund={kpi} />
			))}
		</>
	);
};

export default VInvestExpertiseSynthesisListedAssets;
